import { UserForm } from 'entities/user/index';

const initialFields: UserForm = { name: "", username: "", email: "", phone: "", website: "" }


export default initialFields;